<div
    class="add-control"
    [class]="sideClass()"
    [class.fullWidthBlock]="isFullWidthBlock()"
    [style.opacity]="isShown() ? 1 : 0"
    [style.visibility]="isShown() ? 'visible' : 'hidden'"
>
    <button class="add-btn" [tooltip]="tooltipText()" [adaptivePosition]="true" (click)="onClick()">
        <span class="sp-icon icon-plus-add"> </span>
    </button>

    <button
        webBlockHeightResize
        [edge]="edge()"
        [height]="height()"
        (heightChange)="resizeEvent.emit($event)"
        (heightChangeStart)="resizeStartEvent.emit()"
        (heightChangeEnd)="resizeEndEvent.emit()"
        class="change-height-btn"
        [tooltip]="heightValue"
    ></button>
    <ng-template #heightValue>{{ height() }}</ng-template>
</div>
